<template>
  <WrappedImage
    v-if="logoPath"
    :img-src="logoPath"
    :img-width="imgWidth"
    :img-mt="imgMt"
    :img-align="imgAlign"
  />
</template>
<script>
import WrappedImage from './common/WrappedImage'
export default {
  components: { WrappedImage },
  props: {
    logoColor: {
      type: String,
      validator: value => {
        return ['gray', 'white', 'default'].indexOf(value) !== -1
      }
    },
    imgWidth: {
      type: String
    },
    imgMt: {
      type: String
    },
    imgAlign: {
      type: String
    }
  },
  computed: {
    logoPath() {
      let color = this.logoColor
      let name = 'logo-logo-fundanow-bb'
      if (color === 'gray') {
        name = 'logo-logo-fundanow-g'
      } else if (color === 'white') {
        name = 'logo-fundanow-w'
      }
      return require(`@/assets/images/${name}.svg`)
    }
  }
}
</script>
